/* Disable Dropzone.js automatic convert of elements if dropzone class. Expects already loaded Dropzone object */
Dropzone.autoDiscover = false;

/**
 * Performs repeated initialization of nette.ajax.js
 * (needed when bypassing it to inject HTML directly to the page with ajax links and forms)
 */
Bingo.reinitNetteAjax = function () {
    $.nette.load();
};

Bingo.deleteEmptyValuesFromObject = function (obj) {
    for (const propName in obj) {
        if (obj[propName] === '' || obj[propName] === null || obj[propName] === undefined) {
            delete obj[propName];
        }
    }
};

/**
 * Serialize given object into associative array (object
 * Adapted from: http://stackoverflow.com/questions/1184624/convert-form-data-to-javascript-object-with-jquery
 */
Bingo.serializeObject = function (elem) {
    const o = {};
    const a = elem.serializeArray();
    $.each(a, function () {
        if (o[this.name] !== undefined) {
            if (!o[this.name].push) {
                o[this.name] = [o[this.name]];
            }
            o[this.name].push(this.value || '');
        } else {
            o[this.name] = this.value || '';
        }
    });
    return o;
};

/**
 * This should disable not implemented links so they can not be used.
 */
(function ($) {
    Bingo.disableNotImplementedLinks = function () {
        $('a.not-implemented-yet').click((evt) => {
            evt.preventDefault();
            alert('Not implemented yet!');
        });
    };
    $(document).ready(() => {
        Bingo.disableNotImplementedLinks();
    });
}(jQuery));

// Workaround for Bootstrap preventing Clipboard.js to operate in modals
// See:  https://github.com/zenorocha/clipboard.js/issues/155
$.fn.modal.Constructor.prototype.enforceFocus = function () {};
new Clipboard('.clipboard');

// Fix scrolling problem with modal over modal
// See: http://stackoverflow.com/a/30876481/1359799
$(document).on('hidden.bs.modal', () => {
    if ($('.modal:visible').length) {
        $('body').addClass('modal-open');
    }
});
